<!--
 * @Author: DY
 * @Date: 2024-12-05 16:55:29
 * @LastEditTime: 2025-04-09 15:00:08
 * @Description: 采购计划查询执行情况
 * @FilePath: \ShiMo_Mobile\src\views\storage\dieselFuelRequisitionApproval\form.vue
-->
<template>
    <v-touch @swiperight="closeAllocationForm" class="wrapper">
        <div class="contractInquiryCgForm commonFormStyles">
            <HeaderNav header-title="采购计划执行情况" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: closeAllocationForm }"></HeaderNav>
            <section>
                <van-tabs class="currencyTabsStyle" v-model="activeTab" animated :scrollspy="false">
                    <van-tab title="基本信息表">
                        <div class="formList">
                            <ul class="formItem">
                                <!-- <li class="formItemTitle">
                                    <h5>基本信息</h5>
                                </li> -->
                                <li>
                                    <van-field
                                        disabled
                                        label="采购计划编号"
                                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                        v-model="formData.CollectNumber"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="采购月份"
                                        :left-icon="require('@/assets/images/icons/icon_18@2x.png')"
                                        v-model="formData.CollectMonth"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="采购部门"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="formData.ExecuteDeptName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="采购员"
                                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                        v-model="formData.ExecuteUserName"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="申请方式"
                                        :left-icon="require('@/assets/images/icons/icon_21@2x.png')"
                                        v-model="formData.MethodStr"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="采购总完成率(%)"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.ProucrementFinishRate"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="需求部门"
                                        :left-icon="require('@/assets/images/icons/icon_47@2x.png')"
                                        v-model="formData.ApplyDeptNames"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="预算总价(元)"
                                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                        v-model="formData.BudgetTotal"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="状态"
                                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                        v-model="formData.ExecuteStatusStr"
                                    ></van-field>
                                </li>
                                <li class="formItemStyle">
                                    <van-field
                                        disabled
                                        label="新增采购金额(元)"
                                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                        v-model="formData.NewAddTotal"
                                    ></van-field>
                                </li>
                                <li>
                                    <van-field
                                        disabled
                                        label="备注"
                                        type="textarea"
                                        :rows="2"
                                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                        v-model="formData.Remarks"
                                    ></van-field>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="采购计划明细表">
                        <div class="formList">
                            <ul class="formItem">
                                <!-- <li class="formItemTitle">
                                    <h5>计划明细</h5>
                                </li> -->
                                <dl class="materialList" v-for="(item, index) in formData.Materials" :key="`material_${index}`">
                                    <dt>
                                        <h5>物料代码</h5>
                                        <p>{{ item.MaterialCode }}</p>
                                    </dt>
                                    <dd>
                                        <div>
                                            <p>短描述：</p>
                                            <input type="text" disabled v-model="item.MaterialShortName">
                                        </div>
                                        <div>
                                            <p>单位：</p>
                                            <input type="text" disabled v-model="item.Depts[0].Unit">
                                        </div>
                                        <div>
                                            <p>申请部门：</p>
                                            <input type="text" disabled v-model="item.Depts[0].ApplyDeptName">
                                        </div>
                                        <div>
                                            <p>申请数量：</p>
                                            <input type="text" disabled v-model="item.Depts[0].ApplyCount">
                                        </div>
                                        <div>
                                            <p>采购用途：</p>
                                            <input type="text" disabled v-model="item.Depts[0].Purpose">
                                        </div>
                                        <div>
                                            <p>预算单价：</p>
                                            <input type="text" disabled v-model="item.Depts[0].BudgetUnitPrice">
                                        </div>
                                        <div>
                                            <p>建议采购数量：</p>
                                            <input type="text" disabled v-model="item.Depts[0].SuggestCount">
                                        </div>
                                        <div>
                                            <p>预算总价：</p>
                                            <input type="text" disabled v-model="item.Depts[0].BudgetTotal">
                                        </div>
                                    </dd>
                                </dl>
                            </ul>
                        </div>
                    </van-tab>
                </van-tabs>
            </section>
            <footer class="currencyFooterStyle">
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    name: 'contract-inquiry-cg-form',
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            activeTab: 0,
            formData: {
                Materials: [],
            },
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        async initpage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            this.formData = await this.getFormData(this.$route.params.data.id);
            this.$toast.clear();
        },
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'contractInquiry_cg',
            });
        },
        getFormData(id) {
            return this.$axios.$get(`/interfaceApi/procurement/plan_collect?id=${id}`);
        },
    },
};
</script>
<style lang="stylus">
.contractInquiryCgForm
    background #F0F0F0
    section
        height 0
        flex 1
    .formList
        padding 10rpx
        .formItem
            background #fff
            .photoUpload
                .van-cell
                    border none
                .file-list
                    padding 0 14rpx 10rpx
            .formItemStyle
                .van-cell
                    background: #FDE9DC;
                    .van-cell__title
                        color: #6F2C01;
                    .van-cell__value
                        .van-field__control
                            color: #C84E00
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                h5
                    font-size 16rpx
                    color #e93743
                p
                    margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        font-size 12rpx
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.9)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.9)
</style>